// extracted by mini-css-extract-plugin
module.exports = {"container":"y1_e","imageLabel":"y1_y2","imageInput":"y1_ji","photoIcon":"y1_y3","label":"y1_mo mk_mo"};